module.exports = __webpack_public_path__ + "assets/img/rain-3.d510d467.jpg";